/**
 * v2 Theme - Spacing (8pt grid)
 */
const spacing = {
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,

  pagePadding: {
    mobile: 16,
    tablet: 24,
    desktop: 32,
  },

  section: 32,
  cardPadding: 16,
  formGap: 12,
};

export default spacing;

